__turbopack_context__.v({
  "categorySelect": "index-module-scss-module__u-smqG__categorySelect",
  "filterBar": "index-module-scss-module__u-smqG__filterBar",
  "freqSelect": "index-module-scss-module__u-smqG__freqSelect",
  "group": "index-module-scss-module__u-smqG__group",
});
